import React, { useCallback, useState } from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";
// import { NoticeItem, List } from "../components/";
import { NoticeData } from "../types";
import { withVersionParams } from "../HOC/withVersionParams";
import List from "../components/Common/List";
import NoticeItem from "../components/NoticePage/NoticeItem";
import noticeData from "../constants/NoticeData";
const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
   empty: {
      padding: "21px 0 23px 0",
      width: `calc(100% - ${theme.gap * 2}px)`,
      margin: "0 auto",
   },
}));

const NoticePage = () => {
   const classes = useStyles();

   const [selectedIdx, setIdx] = useState<number>(-1);
   const toggleItem = useCallback(
      (idx: number) => {
         setIdx(selectedIdx !== idx ? idx : -1);
      },
      [selectedIdx]
   );

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>공지사항</title>
            </Helmet>
         </HelmetProvider>
         <div className={classes.wrap}>
            <List
               data={noticeData}
               itemComponent={NoticeItem}
               toggleItem={toggleItem}
               selectedIdx={selectedIdx}
            />
         </div>
      </>
   );
};

export default NoticePage;
